module.exports = __webpack_public_path__ + "images/help/icon-twr50-2b3ddfb96bceeedfb663b67ca58a9749.png";